/**
 * Created by jonas on 2021-03-09.
 */
import {DasUBootGameAssets} from "../../DasUBootGameAssets";
import {DasUBoot} from "../../DasUBoot";
import {gsap} from "gsap";
import {MathUtils} from "../../utils/MathUtils";
import {ReelAvalancheAttention} from "../../components/ReelAvalancheAttention";
import {DasUBootStatics} from "../../utils/DasUBootStatics";
import {XBombMultiplierDisplay} from "./XBombMultiplierDisplay";
import {PossibleWinWaysDisplayCounter} from "./PossibleWinWaysDisplayCounter";
import {DasUBootTorpedoView} from "../DasUBootTorpedoView";
import {DasUBootReelsViewState} from "../../reels/DasUBootReelsView";
import {SpriteUtils} from "../../utils/SpriteUtils";
import {MiniLampState, SpineLamp} from "./SpineLamp";
import {NudgeLamp} from "./NudgeLamp";
import {DasUBootSound} from "../../sound/DasUBootSound";
import {GraphicsPool} from "../../utils/GraphicsPool";
import {SpineGSAPWrapper} from "../../../core/animation/SpineGSAPWrapper";


export enum FrameAnimations {
    m_idle_0 = "m_idle_0",
    m_idle_1 = "m_idle_1",
    m_idle_2 = "m_idle_2",
    m_idle_3 = "m_idle_3",
    m_idle_4 = "m_idle_4",
    m_rotate_0 = "m_rotate_0",
    m_rotate_1 = "m_rotate_1",
    m_rotate_2 = "m_rotate_2",
    m_rotate_3 = "m_rotate_3",
    m_rotate_4 = "m_rotate_4",
    steam_loop_0 = "steam_loop_0",
    steam_loop_1 = "steam_loop_1",
    steam_loop_2 = "steam_loop_2",
    steam_winways = "steam_winways"
}

export class ReelFrame {
    public behindNormalReelsContainer:PIXI.Container;
    public overNormalReelsContainer:PIXI.Container;
    public overWinReelsContainer:PIXI.Container;
    private frameTop:PIXI.Sprite;

    public position:PIXI.ObservablePoint;
    private periscopeBackground:PIXI.Container;
    private periscopeHead:PIXI.Sprite;
    public avalancheAttention:ReelAvalancheAttention;

    private normalAvalancheAttentionMask:PIXI.Graphics;
    private extendedAvalancheAttentionMask:PIXI.Graphics;
    public reelLamps:SpineLamp[];

    public xBombMultiplierDisplay:XBombMultiplierDisplay;
    public possibleWinWaysDisplay:PossibleWinWaysDisplayCounter;
    public frameBottom:PIXI.Container;
    public torpedoView:DasUBootTorpedoView;

    private torpedoTopContainer:PIXI.Container;
    private torpedoBottomContainer:PIXI.Container;

    private reelCover:PIXI.Sprite;
    private _frameSpine:PIXI.spine.Spine;
    private flashEffect:PIXI.Sprite;
    private frameAnimationsTrackIndexMap:Map<FrameAnimations, number>;
    private avalancheReelAttention:PIXI.AnimatedSprite[];


    public onPosition() {
        this.behindNormalReelsContainer.position.set(this.position.x, this.position.y);
        this.overNormalReelsContainer.position.set(this.position.x, this.position.y);
        this.overWinReelsContainer.position.set(this.position.x, this.position.y);
    }

    constructor() {
        this.frameAnimationsTrackIndexMap = new Map<FrameAnimations, number>();
        this.frameAnimationsTrackIndexMap.set(FrameAnimations.m_idle_0, 0);
        this.frameAnimationsTrackIndexMap.set(FrameAnimations.m_idle_1, 1);
        this.frameAnimationsTrackIndexMap.set(FrameAnimations.m_idle_2, 2);
        this.frameAnimationsTrackIndexMap.set(FrameAnimations.m_idle_3, 3);
        this.frameAnimationsTrackIndexMap.set(FrameAnimations.m_idle_4, 4);

        this.frameAnimationsTrackIndexMap.set(FrameAnimations.m_rotate_0, 0);
        this.frameAnimationsTrackIndexMap.set(FrameAnimations.m_rotate_1, 1);
        this.frameAnimationsTrackIndexMap.set(FrameAnimations.m_rotate_2, 2);
        this.frameAnimationsTrackIndexMap.set(FrameAnimations.m_rotate_3, 3);
        this.frameAnimationsTrackIndexMap.set(FrameAnimations.m_rotate_4, 4);

        this.frameAnimationsTrackIndexMap.set(FrameAnimations.steam_loop_0, 5);
        this.frameAnimationsTrackIndexMap.set(FrameAnimations.steam_loop_1, 6);
        this.frameAnimationsTrackIndexMap.set(FrameAnimations.steam_loop_2, 7);
        this.frameAnimationsTrackIndexMap.set(FrameAnimations.steam_winways, 8);


        this.createMasks();
        this.position = new PIXI.ObservablePoint(this.onPosition, this);
        const framePos = new PIXI.Point(-71, -50);

        this.behindNormalReelsContainer = new PIXI.Container();
        this.behindNormalReelsContainer.name = "behindNormalReelsContainer";
        this.overNormalReelsContainer = new PIXI.Container();
        this.overNormalReelsContainer.name = "overNormalReelsContainer";
        this.overWinReelsContainer = new PIXI.Container();
        this.overWinReelsContainer.name = "overWinReelsContainer";

        this.torpedoBottomContainer = new PIXI.Container();
        this.torpedoBottomContainer.name = "torpedoBottomContainer";
        this.torpedoTopContainer = new PIXI.Container();
        this.torpedoTopContainer.name = "torpedoTopContainer";
        this.torpedoView = new DasUBootTorpedoView(this.torpedoBottomContainer, this.torpedoTopContainer);

        const periscopeBackgroundCont = this.createPeriscopeBackground();

        this.avalancheAttention = new ReelAvalancheAttention();
        this.avalancheAttention.position.set(432, 0)
        this.setAvalancheMask(false);


        this.torpedoBottomContainer.addChild(this.torpedoView.backgroundView);
        this.torpedoBottomContainer.addChild(this.torpedoView.topView);

        this.behindNormalReelsContainer.addChild(this.torpedoBottomContainer);
        this.behindNormalReelsContainer.addChild(SpriteUtils.make(DasUBootGameAssets.REEL_FRAME_BACKGROUND, framePos));
        this.behindNormalReelsContainer.addChild(periscopeBackgroundCont);
        this.behindNormalReelsContainer.addChild(this.normalAvalancheAttentionMask);
        this.behindNormalReelsContainer.addChild(this.extendedAvalancheAttentionMask);
        this.behindNormalReelsContainer.addChild(this.avalancheAttention);

        const avalancheReelAttentionTextures = DasUBoot.assetLoader.getTextures(DasUBootGameAssets.AVALANCHE_REEL_ATTENTION);
        this.avalancheReelAttention = [];
        const yMultiples = [1.5, 1, 0, 0, 1, 1.5];
        for (let i:number = 0; i < 6; i++) {
            this.avalancheReelAttention[i] = new PIXI.AnimatedSprite(avalancheReelAttentionTextures, true);
            this.avalancheReelAttention[i].position.set(DasUBootStatics.symbolWidth * i, DasUBootStatics.symbolHeight * yMultiples[i]);
            this.avalancheReelAttention[i].blendMode = PIXI.BLEND_MODES.ADD;
            this.avalancheReelAttention[i].tint = PIXI.utils.string2hex("#00ff00");
            this.avalancheReelAttention[i].visible = false;
            this.avalancheReelAttention[i].animationSpeed = 0.5;
            this.behindNormalReelsContainer.addChild(this.avalancheReelAttention[i]);
        }


        this._frameSpine = GraphicsPool.spineFactory(DasUBootGameAssets.FRAME_SPINE);
        this._frameSpine.stateData.defaultMix = 0.5;
        this._frameSpine.position.set(432, 308);
        this._frameSpine.name = "frame";

        this.frameTop = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.REEL_FRAME_TOP)[0]);
        this.frameTop.name = "frameTop";
        this.frameTop.position.set(framePos.x, framePos.y);


        const grid = ReelFrame.createGrid();
        grid.name = "grid";

        this.xBombMultiplierDisplay = new XBombMultiplierDisplay();
        this.xBombMultiplierDisplay.position.set(0, 0);

        this.possibleWinWaysDisplay = new PossibleWinWaysDisplayCounter();
        this.possibleWinWaysDisplay.position.set(111, 83);

        this.reelCover = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.REEL_COVER)[0]);
        this.reelCover.name = "reelCover";
        this.reelCover.alpha = 0;
        this.reelCover.position.set(-9, -13);


        this.overNormalReelsContainer.addChild(grid);
        this.overNormalReelsContainer.addChild(this.reelCover);
        this.overNormalReelsContainer.addChild(this.frameTop);
        this.overNormalReelsContainer.addChild(this._frameSpine);
        this.overNormalReelsContainer.addChild(this.xBombMultiplierDisplay);
        this.overNormalReelsContainer.addChild(this.possibleWinWaysDisplay);


        //Over Win container
        this.periscopeHead = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.PERISCOPE_HEAD)[0]);
        this.periscopeHead.position.set(280, -139);


        this.frameBottom = new PIXI.Container();
        this.frameBottom.name = "frameBottom";
        const lampContainer = this.createLamps();
        this.frameBottom.addChild(lampContainer);
        this.frameBottom.position.set(0, -20)


        this.flashEffect = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.FLASH)[0]);
        this.flashEffect.anchor.set(0, 0.5);


        this.overWinReelsContainer.addChild(this.torpedoTopContainer);
        this.overWinReelsContainer.addChild(this.frameBottom);
        this.overWinReelsContainer.addChild(this.periscopeHead);
        this.overWinReelsContainer.addChild(this.reelLamps[0]);
        this.overWinReelsContainer.addChild(this.reelLamps[5]);

        this.startFrameIdle();

/*        DevKeyTriggerManager.addTrigger("t", ()=>this.lowerTorpedoTube(true));
        DevKeyTriggerManager.addTrigger("y", ()=>this.lowerTorpedoTube(false));
        DevKeyTriggerManager.addTrigger("g", ()=>DasUBoot.reelView.reelFrame.torpedoView.launchTorpedo(2.0));
        DevKeyTriggerManager.addTrigger("q", ()=>DasUBoot.reelView.reelFrame.torpedoView.loadTorpedo());*/


    }


    //******* CREATE FUNCTIONS

    private createMasks() {
        const normalPolygon:PIXI.Point[] = [
            new PIXI.Point(2, 0),
            new PIXI.Point(3, 0),
            new PIXI.Point(4, 0),
            new PIXI.Point(4, 1),
            new PIXI.Point(5, 1),
            new PIXI.Point(5, 1.5),
            new PIXI.Point(6, 1.5),
            new PIXI.Point(6, 3.5),
            new PIXI.Point(5, 3.5),
            new PIXI.Point(5, 4),
            new PIXI.Point(1, 4),
            new PIXI.Point(1, 3.5),
            new PIXI.Point(0, 3.5),
            new PIXI.Point(0, 1.5),
            new PIXI.Point(1, 1.5),
            new PIXI.Point(1, 1),
            new PIXI.Point(2, 1)
        ];

        for (let i:number = 0; i < normalPolygon.length; i++) {
            normalPolygon[i] = MathUtils.multiplyPoints(normalPolygon[i], new PIXI.Point(144, 144));
        }

        const extendedPolygon:PIXI.Point[] = [
            new PIXI.Point(2, 0),
            new PIXI.Point(2, -2),
            new PIXI.Point(3, -2),
            new PIXI.Point(3, 0),
            new PIXI.Point(4, 0),
            new PIXI.Point(4, 1),
            new PIXI.Point(5, 1),
            new PIXI.Point(5, 1.5),
            new PIXI.Point(6, 1.5),
            new PIXI.Point(6, 3.5),
            new PIXI.Point(5, 3.5),
            new PIXI.Point(5, 4),
            new PIXI.Point(1, 4),
            new PIXI.Point(1, 3.5),
            new PIXI.Point(0, 3.5),
            new PIXI.Point(0, 1.5),
            new PIXI.Point(1, 1.5),
            new PIXI.Point(1, 1),
            new PIXI.Point(2, 1)
        ];

        for (let i:number = 0; i < extendedPolygon.length; i++) {
            extendedPolygon[i] = MathUtils.multiplyPoints(extendedPolygon[i], new PIXI.Point(144, 144));
        }


        this.normalAvalancheAttentionMask = new PIXI.Graphics();
        this.normalAvalancheAttentionMask.beginFill(0x0000ff, 0.25);
        this.normalAvalancheAttentionMask.drawPolygon(normalPolygon);
        this.normalAvalancheAttentionMask.endFill();

        this.extendedAvalancheAttentionMask = new PIXI.Graphics();
        this.extendedAvalancheAttentionMask.beginFill(0x0000ff, 0.25);
        this.extendedAvalancheAttentionMask.drawPolygon(extendedPolygon);
        this.extendedAvalancheAttentionMask.endFill();

    }

    private static createGrid():PIXI.Container {
        const grid = new PIXI.Container();
        const lines = [
            new PIXI.Sprite(PIXI.Texture.WHITE),
            new PIXI.Sprite(PIXI.Texture.WHITE),
            new PIXI.Sprite(PIXI.Texture.WHITE),
            new PIXI.Sprite(PIXI.Texture.WHITE),
            new PIXI.Sprite(PIXI.Texture.WHITE),
            new PIXI.Sprite(PIXI.Texture.WHITE),
            new PIXI.Sprite(PIXI.Texture.WHITE)
        ];

        lines[0].height = DasUBootStatics.symbolHeight * 2;
        lines[1].height = DasUBootStatics.symbolHeight * 3;
        lines[2].height = DasUBootStatics.symbolHeight * 4;
        lines[3].height = DasUBootStatics.symbolHeight * 4;
        lines[4].height = DasUBootStatics.symbolHeight * 4;
        lines[5].height = DasUBootStatics.symbolHeight * 3;
        lines[6].height = DasUBootStatics.symbolHeight * 2;


        lines[0].position.set(0, DasUBootStatics.symbolHeight * 1.5);
        lines[1].position.set(DasUBootStatics.symbolWidth, DasUBootStatics.symbolHeight);
        lines[2].position.set(DasUBootStatics.symbolWidth * 2, 0);
        lines[3].position.set(DasUBootStatics.symbolWidth * 3, 0);
        lines[4].position.set(DasUBootStatics.symbolWidth * 4, 0);
        lines[5].position.set(DasUBootStatics.symbolWidth * 5, DasUBootStatics.symbolHeight);
        lines[6].position.set(DasUBootStatics.symbolWidth * 6, DasUBootStatics.symbolHeight * 1.5);

        for (let line of lines) {
            line.tint = 0x000000;
            line.width = 4;
            grid.addChild(line);
            line.anchor.set(0.5, 0);
        }

        return grid;
    }

    private createLamps():PIXI.Container {
        this.reelLamps = [
            new SpineLamp(DasUBootGameAssets.LAMP_LEFT),
            new SpineLamp(DasUBootGameAssets.LAMP_X_WAYS),
            new NudgeLamp(DasUBootGameAssets.LAMP_X_NUDGE),
            new NudgeLamp(DasUBootGameAssets.LAMP_X_NUDGE),
            new SpineLamp(DasUBootGameAssets.LAMP_X_WAYS),
            new SpineLamp(DasUBootGameAssets.LAMP_RIGHT)
        ];
        const lampContainer = new PIXI.Container();
        lampContainer.name = "lampContainer";
        lampContainer.addChild(...this.reelLamps);
        lampContainer.position.set(72, 600);
        this.reelLamps[0].position.set(75, 562);
        this.reelLamps[1].position.set(144, 0);
        this.reelLamps[2].position.set(288, 0);
        this.reelLamps[3].position.set(432, 0);
        this.reelLamps[4].position.set(576, 0);
        this.reelLamps[5].position.set(773, 557);

        return lampContainer;

    }

    private createPeriscopeBackground() {
        const container = new PIXI.Container();
        container.name = "PersicopeBG"
        const background = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.PERISCOPE_BACKGROUND)[0]);
        background.position.set(278, -66);

        const mask = new PIXI.Graphics();
        mask.beginFill(0xff0000, 0.4);
        mask.drawRect(0, 0, background.width, -360);
        mask.position.set(278, 0);

        background.mask = mask;
        container.addChild(background, mask);

        this.periscopeBackground = background;

        return container;
    }


    //******* ANIMATIONS

    public getFlashAnimation(duration:number, fromPos:PIXI.Point, toPos:PIXI.Point):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.flashEffect.position.set(fromPos.x, fromPos.y);
            this.flashEffect.rotation = MathUtils.angleBetweenPoints(fromPos, toPos);
            this.flashEffect.width = MathUtils.distanceBetweenPoints(fromPos, toPos);
            this.flashEffect.alpha = 1;
            this.overWinReelsContainer.addChild(this.flashEffect);
        });
        tl.add(() => DasUBoot.soundPlayer.playSingleSound(DasUBootSound.X_BOMB_LIGHTNING));
        tl.add(gsap.to(this.flashEffect, {
            duration:duration,
            ease:"power4.out",
            alpha:0,
        }));
        tl.add(() => {
            this.overWinReelsContainer.removeChild(this.flashEffect);
        });

        return tl;
    }

    public openPeriscope(duration:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        const topPart = gsap.timeline();
        topPart.add(gsap.to(this.frameTop, {duration:0.1, pixi:{pivotY:10}}));
        topPart.add(gsap.to(this.frameTop, {duration:0.2, pixi:{pivotX:-155}}));

        tl.add([
            topPart,
            gsap.to(this.periscopeBackground, {duration:duration, pixi:{pivotY:290}}),
            gsap.to(this.periscopeHead, {duration:duration, pixi:{pivotY:290}})
        ]);
        tl.add(() => {
            this.setAvalancheMask(true);
        })


        return tl;
    }

    public closePeriscope(duration:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this.setAvalancheMask(false);
        })

        tl.add([
            gsap.to(this.periscopeBackground, {duration:duration, pixi:{pivotY:0}}),
            gsap.to(this.periscopeHead, {duration:duration, pixi:{pivotY:0}})
        ]);

        const topPart = gsap.timeline();
        topPart.add(gsap.to(this.frameTop, {duration:0.2, pixi:{pivotX:0}}));
        topPart.add(gsap.to(this.frameTop, {duration:0.1, pixi:{pivotY:0}}));

        tl.add(topPart, ">-" + topPart.duration());


        return tl;
    }

    public lowerTorpedoTube(lower:boolean, duration:number = 1.0):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        duration = duration == 0 ? 0.0001 : duration;

        if (lower) {
            tl.add(DasUBoot.reelView.getAnimationTimeResize(duration, DasUBootReelsViewState.TORPEDO));
            tl.add([
                gsap.to(this.torpedoView.pivot, {duration:duration, y:-144, ease:"none"}),
                () => DasUBoot.soundPlayer.playSound(DasUBootSound.TORPEDO_COVER_DOWN)
            ], "-=0.25");
            // tl.add(gsap.to(this.frameBottom.pivot, {duration:duration, y:-144, ease:"none"}), "<");
            tl.add(this.torpedoView.loadTorpedo());

        } else {
            tl.add([
                gsap.to(this.torpedoView.pivot, {duration:duration, y:0, ease:"none"}),
                () => DasUBoot.soundPlayer.playSound(DasUBootSound.TORPEDO_COVER_UP)
            ]);
            // tl.add(gsap.to(this.frameBottom.pivot, {duration:duration, y:0, ease:"none"}), "<");
            //tl.add(this.torpedoView.unLoadTorpedo(duration), "<");
            tl.add(DasUBoot.reelView.getAnimationTimeResize(duration, DasUBootReelsViewState.NORMAL), "-=0.25");
            tl.add(() => this.torpedoView.deleteTorpedo());
        }

        return tl;

    }

    public animateXLamps(show:boolean = true):gsap.core.Tween {
        //const tl:gsap.core.Timeline = gsap.timeline();
        if (!show) {
            return gsap.to(this.frameBottom, {duration:0.2, alpha:0});
        } else {
            return gsap.to(this.frameBottom, {duration:0.2, alpha:1});
        }

    }


    //******* UTILS
    private setAvalancheMask(extended:boolean = false) {
        if (extended) {
            this.avalancheAttention.mask = this.extendedAvalancheAttentionMask;
            this.normalAvalancheAttentionMask.visible = false;
            this.extendedAvalancheAttentionMask.visible = true;
        } else {
            this.avalancheAttention.mask = this.normalAvalancheAttentionMask;
            this.normalAvalancheAttentionMask.visible = true;
            this.extendedAvalancheAttentionMask.visible = false;
        }
    }

    public switchLampOnReel(reel:number, value:number = -1) {
        this.reelLamps[reel].setValue(value);
    }

    public switchMiniLamps(state:MiniLampState, lampIndices:number[]) {
        for (let index of lampIndices) {
            this.reelLamps[index].setMiniLampState(state);
        }
    }

    showCover(duration:number = 0.5):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(gsap.to(this.reelCover, {duration:duration, alpha:1}));
        return tl;
    }

    hideCover():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(gsap.to(this.reelCover, {duration:0.5, alpha:0}));
        return tl;
    }


    private startFrameIdle() {
        //there is 5 meeters
        this.setFrameAnimation(FrameAnimations.m_idle_0, true);
        this.setFrameAnimation(FrameAnimations.m_idle_1, true);
        this.setFrameAnimation(FrameAnimations.m_idle_2, true);
        this.setFrameAnimation(FrameAnimations.m_idle_3, true);
        this.setFrameAnimation(FrameAnimations.m_idle_4, true);
        this.clearFrameAnim(FrameAnimations.steam_loop_0);
        this.clearFrameAnim(FrameAnimations.steam_loop_1);
        this.clearFrameAnim(FrameAnimations.steam_loop_2);


    }

    public playWinWaysSteam() {
        const index = this.frameAnimationsTrackIndexMap.get(FrameAnimations.steam_winways)!;
        const tl = SpineGSAPWrapper.createTimeline(this._frameSpine, index, FrameAnimations.steam_winways, 0, 1);
        tl.add(() => DasUBoot.soundPlayer.playSound(DasUBootSound.POSSIBLE_WIN_WAYS_DISPLAY_STEAM), 0);
        tl.add(() => {this._frameSpine.state.setEmptyAnimation(index, 0)});
    }

    public setFrameAnimation(anim:FrameAnimations, loop:boolean) {
        const index = this.frameAnimationsTrackIndexMap.get(anim)!;
        this._frameSpine.state.setAnimation(index, anim, loop);
    }

    public isPlaying(animName:FrameAnimations):boolean {
        const index = this.frameAnimationsTrackIndexMap.get(animName)!;
        return this._frameSpine.state.getCurrent(index)?.animation?.name == animName;
    }

    public clearFrameAnim(anim:FrameAnimations) {
        const index = this.frameAnimationsTrackIndexMap.get(anim)!;
        this._frameSpine.state.setEmptyAnimation(index, 0.5);
    }


    public startScatterAttention(scatterCount:number) {
        if (scatterCount == 1) {
            this.setFrameAnimation(FrameAnimations.steam_loop_1, true);
            this.setFrameAnimation(FrameAnimations.m_rotate_1, true);
            DasUBoot.soundPlayer.playSound(DasUBootSound.AIR_PRESSURE_1);
        } else if (scatterCount == 2) {
            this.setFrameAnimation(FrameAnimations.steam_loop_2, true);
            this.setFrameAnimation(FrameAnimations.m_rotate_3, true);
            DasUBoot.soundPlayer.playSound(DasUBootSound.AIR_PRESSURE_2);
        } else if (scatterCount == 3) {
            this.setFrameAnimation(FrameAnimations.steam_loop_0, true);
            this.setFrameAnimation(FrameAnimations.m_rotate_0, true);
            DasUBoot.soundPlayer.playSound(DasUBootSound.AIR_PRESSURE_3);
        }
    }

    public stopScatterAttention() {

        if (this.isPlaying(FrameAnimations.steam_loop_1)) {
            DasUBoot.soundPlayer.stopSound(DasUBootSound.AIR_PRESSURE_1);
            this.clearFrameAnim(FrameAnimations.steam_loop_1);
        }

        if (this.isPlaying(FrameAnimations.steam_loop_2)) {
            DasUBoot.soundPlayer.stopSound(DasUBootSound.AIR_PRESSURE_2);
            this.clearFrameAnim(FrameAnimations.steam_loop_2);
            DasUBoot.soundPlayer.playSound(DasUBootSound.AIR_PRESSURE_END_2);
        }

        if (this.isPlaying(FrameAnimations.steam_loop_0)) {
            DasUBoot.soundPlayer.stopSound(DasUBootSound.AIR_PRESSURE_3);
            this.clearFrameAnim(FrameAnimations.steam_loop_0);
            DasUBoot.soundPlayer.playSound(DasUBootSound.AIR_PRESSURE_END_3);
        }

        this.setFrameAnimation(FrameAnimations.m_idle_1, true);
        this.setFrameAnimation(FrameAnimations.m_idle_3, true);
        this.setFrameAnimation(FrameAnimations.m_idle_0, true);

    }

    public playAvalancheNearWin(reel:number) {
        this.avalancheReelAttention[reel].visible = true;
        this.avalancheReelAttention[reel].play();

    }

    public stopAvalancheNearWin(reel:number) {
        this.avalancheReelAttention[reel].visible = false;
        this.avalancheReelAttention[reel].stop();

    }

}